import React from 'react';
import Colors from 'pubweb-smokey/dist/colors';
import PropTypes from 'prop-types';
import SelectableCardStyles from './SelectableCard.styled';

const SelectableCard = ({
  text,
  disabled,
  primaryColor,
  isSelected,
  automationId,
  onCardClick,
  cardID,
  ...props
}) => {
  const propertyClasses = [];

  propertyClasses.push(primaryColor.className);
  propertyClasses.push(isSelected ? 'selected' : '');

  return (
    <SelectableCardStyles
      className={propertyClasses}
      isSelected={isSelected}
      id={automationId ? 'automation-id-' + automationId : cardID}
      onClick={onCardClick}
      disabled={disabled}
      {...props}
    >
      <p className="card-text">{text}</p>
    </SelectableCardStyles>
  );
};

export default SelectableCard;

SelectableCard.defaultProps = {
  text: '',
  primaryColor: Colors.primary.claytonBlue,
  isSelected: false,
  disabled: false,
};

SelectableCard.propTypes = {
  text: PropTypes.string.isRequired,
  primaryColor: PropTypes.oneOf([
    Colors.primary.claytonBlue,
    Colors.secondary.kiddiePool,
    Colors.secondary.summerNight,
    Colors.accent.ladyBug,
    Colors.accent.cheesePuff,
    Colors.secondary.rubberDucky,
  ]),
  isSelected: PropTypes.bool,
  onChange: PropTypes.func,
  cardID: PropTypes.string,
  automationId: PropTypes.string,
  disabled: PropTypes.bool,
  onCardClick: PropTypes.func,
};
